<template>
  <hr :class="variant" />
</template>
<style scoped>
.none {
  border: none;
  width: 100%;
}
.success {
  border: none;
  border-top: 0.05rem solid #2db782;
  width: 100%;
}
</style>
<script>
export default {
  meta: {
    description: 'Personalización del HR para adaptación a los diseños.',
    slots: {
      default: {
        type: 'component',
        valid: [],
      },
    },
  },
  // variant: Clase css.
  props: {
    id: {
      type: String,
      default: '',
      meta: {
        description: 'Id del componente CustomHR',
        example: 'IdCustomHR',
      },
    },
    variant: {
      type: String,
      default: '',
      meta: {
        description: 'Establece los estilos del componente',
        example: 'Texto Necesario',
      },
    },
  },
};
</script>
